import React from "react";
import { formatNumber, formatPercent } from "~/utility/volby2026";

type Candidate = {
  first_name?: string;
  last_name?: string;
  name?: string;
  parties: string;
  votes: number;
  votes_pct: number;
};

type Props = {
  regionName: string;
  chair: Candidate | null;
};

const RegionChairCard = ({ regionName, chair }: Props) => {
  const name = chair ? (chair.name || `${chair.first_name || ""} ${chair.last_name || ""}`.trim()) : "";
  return (
    <div className="v26-chair-card">
      <div className="v26-chair-region">{regionName}</div>
      {chair ? (
        <>
          <div className="v26-chair-name">{name}</div>
          <div className="v26-chair-pct">{formatPercent(chair.votes_pct)}</div>
          <div className="v26-chair-votes">{formatNumber(chair.votes)} platných hlasov</div>
        </>
      ) : (
        <div className="v26-chair-pending">Zatiaľ bez výsledkov</div>
      )}
    </div>
  );
};

export default RegionChairCard;
